
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import ActionsFilterCard from '@/components/activities/FilterCard.vue';

import { BookingsApi } from '@/api/BookingsApi';

import { ActivitiesApi } from '@/api/ActivitiesApi';

import { mapState } from 'vuex';

import { MetaInfo } from 'vue-meta';

import { first, mapValues, sortBy } from 'lodash';

import { findColor, findDate } from '@/config/functions';

@Component({
   computed: {
      ...mapState({
         acc_colors: (s: any) => s.activities.colors,
      }),
   },
   metaInfo(): MetaInfo {
      return {
         title: '',
         titleTemplate: 'Transfer report',
      };
   },
   filters: {
      toFixed2: (value: string) => parseInt(value).toFixed(2),
      formatDate: (act_day: any) => (act_day != null ? new Date(act_day * 8.64e7).toISOString() : ''),
   },
   components: {
      ActionsFilterCard,
   },
})
export default class Transfers extends Booking {
   accommodations: any[] = [];

   stripos!: any;

   addColorTooltips!: any;

   activities: any[] = [];

   guides: any[] = [];

   transfers: any[] = [];

   suppliers: any[] = [];

   acc_colors!: any[];

   activities_colors!: any[];

   payment_colors!: any[];

   customFormatter!: any;

   formatterDate!: any;

   formatTime!: any;

   default_colors!: any;

   fields: any[] = [];

   allAccommodations: any[] = [];

   orders: any[] = [];

   filtered: any[] = [];

   dateRange: Date[] = [];

   filter: any = {
      ...this.default_colors,

      o_group_color: '#FEFEFE',
      moto_overal_status: '#ffffff',
      act_status: '#ffffff',
      transfer_payment_status: '#ffffff',

      moto_lead_guest: '',
      acс_number_rooms: '',
      acс_checkin_date: '',
      acс_nts: '',
      acс_cost: '',
      acс_supp_name: '',
      moto_acс_form: '',

      accommodations: [],

      activities: [],
      activity_search: '',

      suppliers: [],
      supplier_search: '',

      transfers: [],
      transfers_search: '',
   };

   created(): void {
      const $start = this.$moment(this.$localStorage.getItem('activities-list.startDate'));
      const $end = this.$moment(this.$localStorage.getItem('activities-list.endDate'));

      this.dateRange = [
         $start.isValid() ? $start.toDate() : this.$moment().toDate(),
         $end.isValid()
            ? $end.toDate()
            : this.$moment()
                 .add(30, 'd')
                 .toDate(),
      ];

      this.fields = [
         {
            key: 'act_status',
            label: 'TRANSF STATUS',
            thAttr: {
               style: 'width: 52px;',
            },
         },
         {
            key: 'moto_overal_status',
            label: 'GROUP STATUS',
            thAttr: {
               style: 'width: 50px;',
            },
         },
         {
            key: 'o_group_color',
            label: 'group color',
            thAttr: {
               style: 'width: 43px;',
            },
         },
         {
            key: 'activity_day',
            sortable: true,
            label: 'Activity day',
            tdClass: 'text-center',
            thAttr: {
               style: 'width: 100px;',
            },
            formatter: (value: string) => this.$moment(value).format('DD.MM.YYYY'),
         },
         {
            key: 'act_time',
            sortable: true,
            label: 'pick up time',
            tdClass: 'text-center',
            thAttr: {
               style: 'width: 70px;',
            },
            formatter: (value: string) => this.formatTime(value),
         },
         {
            key: 'act_pax',
            sortable: true,
            label: 'pax',
            tdClass: 'text-center',
            thAttr: {
               style: 'width: 50px;',
            },
         },
         {
            key: 'moto_our_reference',
            sortable: true,
            label: 'GROUP REFERENCE',
            tdClass: 'text-center',
            thAttr: {
               style: 'width: 80px;',
            },
         },
         {
            key: 'moto_lead_guest',
            sortable: true,
            label: 'main guest',
            thAttr: {
               style: 'width: 100px;',
            },
            tdClass: 'text-center',
         },
         /*
         {
            key: 'moto_group_phone',
            sortable: true,
            label: 'main guest phone',
            tdClass: 'text-center',
            thAttr: {
               style: 'width: 100px;',
            },
         },
         */
         {
            key: 'act_name',
            sortable: true,
            label: 'activity',
            thAttr: {
               //style: 'width: 180px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'transfer_supplier_name',
            sortable: true,
            label: 'TRANSFER',
            thAttr: {
               //style: 'width: 180px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'act_waiting_time',
            sortable: true,
            label: 'waiting time',
            thAttr: {
               style: 'width: 70px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'act_transfer_zone',
            sortable: true,
            label: 'zone',
            thAttr: {
               style: 'width: 55px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'act_address_phone',
            sortable: true,
            label: 'activity address, phone',
            thAttr: {
               //style: 'width: 150px;',
            },
            tdClass: 'text-center',
         },
         /*
         {
            key: 'act_direction',
            sortable: true,
            label: 'activity direction',
            thAttr: {
               style: 'width: 70px;',
            },
            tdClass: 'text-center',
         },
         */
         {
            key: 'act_waze',
            sortable: true,
            label: 'Activity Waze link',
            thAttr: {
               style: 'width: 80px;',
            },
            tdAttr: {
               style: 'width: 80px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'act_transfer_driver_notes',
            sortable: true,
            label: 'TRANSFER NOTES (DRIVER)',
            thAttr: {
               //style: 'width: 250px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'act_guide',
            sortable: true,
            label: 'GUIDE',
            thAttr: {
               style: 'width: 120px;',
            },
            tdAttr: {
               style: 'width: 120px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'arrival_info',
            sortable: true,
            label: 'Arrival Flight Nr, Date, time',
            thAttr: {
               style: 'width: 120px;',
            },
            tdAttr: {
               style: 'width: 120px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'departure_info',
            sortable: true,
            label: 'Departure Flight Nr, Date, time',
            thAttr: {
               style: 'width: 120px;',
            },
            tdAttr: {
               style: 'width: 120px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'moto_group_accommodation_address',
            sortable: true,
            label: 'Group accommodation address',
            thAttr: {
               //style: 'width: 150px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'act_start_time',
            sortable: true,
            label: 'Activity Start Time',
            thAttr: {
               style: 'width: 55px;',
            },
            tdClass: 'text-center',
            formatter: (value: string) => this.formatTime(value),
         },
         {
            key: 'act_transfer_group_notes',
            sortable: true,
            label: 'TRANSFER NOTES (GROUP)',
            thAttr: {
               //style: 'width: 150px;',
            },
            tdClass: 'text-center',
         },
         {
            key: 'transfer_cost',
            sortable: true,
            label: 'COST €',
            tdClass: 'text-center',
            formatter: (value: string) => this.$options.filters?.toFixed2(value),
         },
         {
            key: 'transfer_payment_status',
            sortable: false,
            label: 'payment status',
            thClass: 'text-center',
            tdClass: 'text-center',
         },
      ];

      this.filter = {
         ...this.filter,
         ...mapValues(this.$route.query, (val: string) => {
            const value = val.split(';');
            return value.length == 1 ? first(value) : value;
         }),
      };
   }

   beforeDestroy(): void {
      this.$store.commit('showLoading');
   }

   filterData() {
      const filter = {
         ...this.default_colors,

         o_group_color: '#FEFEFE',

         act_status: '#ffffff',
         moto_lead_guest: '',
         acс_number_rooms: '',
         acс_checkin_date: '',
         acс_nts: '',
         acс_cost: '',
         moto_acс_form: '',
         acс_supp_name: '',
         accommodations: [],

         ...this.filter,
      };

      this.filtered = this.orders.filter(a => {
         const filtered: any = {
            transfer_payment_status:
               !filter['transfer_payment_status'].length ||
               findColor(
                  filter['transfer_payment_status'],
                  a.transfer_payment_status,
                  this.default_colors?.transfer_payment_status,
                  this.payment_colors
               ),

            suppliers: !filter['suppliers'].length || filter['suppliers'].includes(parseInt(a?.supplier_id)),
            activities: !filter['activities'].length || filter['activities'].includes(parseInt(a?.act_id)),
            transfers: !filter['transfers'].length || filter['transfers'].includes(parseInt(a?.transfer_supplier_id)),
            guides: !filter['guides'] || !filter['guides'].length || filter['guides'].includes(parseInt(a?.guide_id)),

            act_day: findDate(filter['act_day'], a.act_day),
         };

         for (const f of Object.keys(filter)) {
            if (!a[f] || Object.keys(filtered).includes(f)) continue;

            if (f.indexOf('_status') >= 0 || f.indexOf('_color') >= 0) {
               filtered[f] = !filter[f].length || findColor(filter[f], a[f], this.default_colors[f]);
               continue;
            }

            filtered[f] = filter[f] === '' || this.stripos(a[f], filter[f]);
         }

         return Object.keys(filtered).length == Object.values(filtered).filter(f => f).length;
      });
   }

   createReport(id: number, rep_code: string, type: string, act_id: number | null) {
      this.$store.commit('showLoading');
      ActivitiesApi.createReport({ id, rep_code, type, act_id }).finally(() => this.$store.commit('hideLoading'));
   }

   download(type: string) {
      const $body = this.downloadData();

      const $fields = this.fields.map((f: any) => ({
         header: f.label.toUpperCase(),
         key: f.key,
         hidden: false,
         width: ['moto_lead_guest'].includes(f.key) ? 32 : 12,
      }));

      // @ts-ignore
      this.__download(type, $fields, $body, [this.dateRange[0], this.dateRange[1]].map((r: any) => this.$moment(r).format('DD.MM.YYYY')).join('-'));
   }

   downloadData() {
      const keys = this.fields.map((f: any) => f.key);

      const filtered = sortBy(this.filtered, 'acс_checkin_date');

      return filtered.map((item: any) => {
         const result: any[] = [];

         for (const key of keys) {
            let value = item[key] ? item[key] : '';

            switch (key) {
               case 'acс_checkin_date':
                  value = this.$moment(item.acс_checkin_date).format(this.customFormatter.dateFormat);
                  break;

               case 'act_day':
               case 'activity_day':
                  value = this.$moment(item[key]).format('DD.MM.YYYY');
                  break;

               case 'acс_status':
                  if (item.acс_status_name != '' && item.acс_status != '') {
                     value = item.acс_status_name;
                  }
                  break;

               case 'acс_cost':
                  value = parseInt(item.acс_cost).toFixed(2);
                  break;
            }

            result.push({ key, value });
         }

         return result;
      });
   }

   findOrders() {
      this.$store.commit('showLoading');

      const params = {
         dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
      };

      if (!this.dateRange[0] || !this.dateRange[1]) return;

      this.$store.commit('setItems', { name: 'ready', value: false });

      Promise.all([this.$store.dispatch('activities/GET_DICTIONARIES'), ActivitiesApi.transfers(params), ActivitiesApi.getActSuppTransfGuidesData()])
         .then((data: any[]) => {
            this.orders = sortBy(
               data[1]['Activities'].map((item: any) => this.formatOrder(item)),
               'act_day'
            );

            this.activities = sortBy(data[2]['Activities'], 'o_name');
            this.transfers = sortBy(data[2]['Transfer suppliers'], 'o_name');
            this.guides = sortBy(data[2]['Guides'], 'o_name');
            this.suppliers = sortBy(data[2]['Activity suppliers'], 'o_name');
         })
         .finally(() => {
            this.addColorTooltips(['.orders-list'], this.acc_colors);
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   formatOrder(order: any) {
      const activity_day = this.$moment([this.formatterDate(order.act_day), this.formatTime(order.act_time)].join(' ').trim()).valueOf();
      return { ...order, activity_day };
   }

   updateActivityValue(table: string, text: string, field: number, data: any) {
      const order = first(this.orders.filter((o: any) => o.id === data.item.id));
      const index = data.item.activity.index;

      order[table][index][field] = text;

      this.$store.commit('showLoading');

      // @ts-ignore
      BookingsApi.saveOrder(order.id, { o_id: order.id, [table]: order[table] }).then(result => {
         this.orders = this.orders.map((obj: any) => (obj.o_id === result.o_id ? result : obj));
      });
   }

   changePaymentStatus($event: any, data: any) {
      data.transfer_payment_status = first(this.payment_colors.filter(a => a.d_color_code == $event))?.id;

      BookingsApi.changePaymentStatus(
         {
            group_id: data.moto_id,
            activity_id: data.act_id,
            transfer_id: data.transfer_supplier_id,
            act_date: this.formatterDate(data.act_day),
            act_time: this.formatTime(data.act_time),
            payment_status: data.transfer_payment_status,
         },
         'transfer'
      );
   }

   @Watch('$route', { immediate: false, deep: true })
   onRoute(n: any, o: any) {
      if (n.name !== o.name) {
         this.findOrders();
      }
   }

   @Watch('dateRange', { immediate: false, deep: true })
   onChangeDateRange(n: string[]) {
      if (n.length) {
         this.$localStorage.setItem('activities-list.startDate', n[0]);
         this.$localStorage.setItem('activities-list.endDate', n[1]);
         this.findOrders();
      }
   }

   @Watch('orders')
   changeOrders() {
      this.allAccommodations = [];

      this.filterData();
   }

   tbodyTrClass(row: any) {
      return [this.formatterDate(row.acс_checkin_date) == this.$moment().format('YYYY-MM-DD') ? 'today' : ''];
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any, old: any) {
      const query = mapValues({ ...this.$route.query, ...filter }, value => {
         return Array.isArray(value) ? value.join(';') : value;
      });

      if (query['acс_checkin_date'] != null) {
         query['acс_checkin_date'] = this.$moment(query['acс_checkin_date']).format();
      }

      if (query.accommodations !== undefined) {
         delete query.accommodations;
      }

      this.$router.push({ query }).catch(() => {});

      this.filterData();
   }
}
